import { render, staticRenderFns } from "./poiDataForm.vue?vue&type=template&id=45bb6e08&"
import script from "./poiDataForm.vue?vue&type=script&lang=js&"
export * from "./poiDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports